import { useEmbedContext } from '@thoughtspot/blink-context';
import { useTranslation } from '@thoughtspot/i18n';
import { ActionMenu, } from '@thoughtspot/radiant-react/widgets/action-menu';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { Icon, IconColor, IconID, IconSize, } from '@thoughtspot/radiant-react/widgets/icon';
import { Horizontal, Vertical, View, } from '@thoughtspot/radiant-react/widgets/layout';
import { RoutedLink } from '@thoughtspot/radiant-react/widgets/link';
import { Popover } from '@thoughtspot/radiant-react/widgets/popover';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import _ from 'lodash';
import React from 'react';
import { handleClick } from "../utils/nav-config.util";
import styles from './top-nav.module.scss';
export var QuickLink;
(function (QuickLink) {
    QuickLink["SEARCH_DATA"] = "search-data";
    QuickLink["LIVEBOARDS"] = "liveboards";
    QuickLink["ANSWERS"] = "answers";
})(QuickLink || (QuickLink = {}));
export var ApplicationSwitcherTestIds;
(function (ApplicationSwitcherTestIds) {
    ApplicationSwitcherTestIds["ApplicationSwitcherButton"] = "application-switcher-button";
    ApplicationSwitcherTestIds["ApplicationSwitcherMenu"] = "application-switcher-menu";
    ApplicationSwitcherTestIds["AdminIcon"] = "application-switcher-icon-community";
})(ApplicationSwitcherTestIds || (ApplicationSwitcherTestIds = {}));
const isApplicationSelected = (config, activeApplicationID) => {
    return !!activeApplicationID && config?.id === activeApplicationID;
};
const getNavLinkCustomContent = (queryBuilderString, toggleSwitcherMenu, openPage, uri) => {
    return (React.createElement(RoutedLink, { href: uri, onClick: () => {
            toggleSwitcherMenu();
            openPage();
        }, noUderline: true },
        React.createElement(Horizontal, { vAlignContent: "center", className: styles.customContentNav },
            React.createElement(Typography, { variant: "body-normal", "data-testid": queryBuilderString, className: styles.navLinkCustomContentText }, queryBuilderString))));
};
const getCustomContent = (config) => {
    const dataTestId = config.name.split(' ').join('_');
    return (React.createElement(Horizontal, { vAlignContent: "center", className: styles.customContent },
        React.createElement(View, { className: styles.icon, vAlignContent: "center", hAlignContent: "center", grow: 0, shrink: 0 },
            React.createElement(Icon, { "data-testid": `application-switcher-icon-${config.icon}`, id: config.icon, size: IconSize.XLARGE, color: IconColor.WHITE })),
        React.createElement(Vertical, { vAlignContent: "center", className: styles.text },
            React.createElement(Typography, { variant: "content-label-subhead", className: styles.name, "data-testid": `application-switcher-label-${dataTestId}` }, config.name),
            React.createElement(Typography, { "data-testid": `application-switcher-desc-${dataTestId}`, variant: "caption", color: Colors.gray, className: styles.description }, config.description))));
};
export const ApplicationSwitcher = ({ configs, activeApplicationID, sendMixpanelEvent, openQueryBuilder, openAnswerListPage, openLiveboardListPage, getCurrentPathByLocationHash, isReactShellEnabled, }) => {
    const { t } = useTranslation();
    const embedConfig = useEmbedContext();
    const { hiddenHomeLeftNavItems } = embedConfig;
    const [isSwitcherMenuVisible, setIsSwitcherMenuVisible] = React.useState(false);
    const toggleSwitcherMenu = () => {
        setIsSwitcherMenuVisible(prevState => !prevState);
    };
    const buttonRef = React.useRef(null);
    const quickLinkItems = [
        {
            id: 'searchData',
            label: t('gnav.appSwitcher.SEARCH_DATA'),
            action: openQueryBuilder,
            path: '/#/insights/answer',
            hide: _.includes(hiddenHomeLeftNavItems, QuickLink.SEARCH_DATA),
        },
        {
            id: 'viewAllLiveboards',
            label: t('gnav.appSwitcher.ALL_LIVEBOARDS'),
            action: openLiveboardListPage,
            path: '/#/insights/home/liveboards',
            hide: _.includes(hiddenHomeLeftNavItems, QuickLink.LIVEBOARDS),
        },
        {
            id: 'viewAllAnswers',
            label: t('gnav.appSwitcher.ALL_ANSWERS'),
            action: openAnswerListPage,
            path: '/#/insights/home/answers',
            hide: _.includes(hiddenHomeLeftNavItems, QuickLink.ANSWERS),
        },
    ];
    const menuItemGroups = [
        {
            title: 'application list',
            items: configs.map(config => ({
                id: config.name,
                isSelected: isApplicationSelected(config, activeApplicationID),
                customContent: (React.createElement(RoutedLink, { href: `/#${config.target.routerURI ??
                        config.target.uri}`, onClick: () => {
                        const isCurrentApplication = isApplicationSelected(config, activeApplicationID);
                        handleClick(config, isCurrentApplication, getCurrentPathByLocationHash, isReactShellEnabled);
                        toggleSwitcherMenu();
                        sendMixpanelEvent(config.name);
                    }, noUderline: true }, getCustomContent(config))),
            })),
        },
        {
            title: 'navigation links',
            items: quickLinkItems
                .filter(item => !item.hide)
                .map(item => ({
                id: item.id,
                customContent: getNavLinkCustomContent(item.label, toggleSwitcherMenu, item.action, item.path),
            })),
        },
    ];
    const SwitcherMenu = (React.createElement(ActionMenu, { menuItemGroups: menuItemGroups, show: isSwitcherMenuVisible, "data-testid": ApplicationSwitcherTestIds.ApplicationSwitcherMenu, className: styles.actionMenu }));
    React.useEffect(() => {
        if (!isSwitcherMenuVisible) {
            document?.querySelector(`#${ApplicationSwitcherTestIds.ApplicationSwitcherButton} > button`)?.focus();
        }
    }, [isSwitcherMenuVisible]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: buttonRef },
            React.createElement(Button, { onClick: toggleSwitcherMenu, icon: IconID.NINE_SQUARES, isSelected: isSwitcherMenuVisible, type: "secondary", "data-testid": ApplicationSwitcherTestIds.ApplicationSwitcherButton, id: ApplicationSwitcherTestIds.ApplicationSwitcherButton })),
        React.createElement(Popover, { targetRef: buttonRef, align: "bottom-end", className: styles.popover, isVisible: isSwitcherMenuVisible, content: SwitcherMenu, onClickOutside: () => {
                setIsSwitcherMenuVisible(false);
            }, onEscape: (e) => {
                setIsSwitcherMenuVisible(false);
            } })));
};
//# sourceMappingURL=application-switcher.js.map